import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';

const WEBSITE_ID = process.env.REACT_APP_CRISP_WEBSITE_ID;

export default function CrispChat() {
  const { user } = useAuth();
  const loaded = useRef(false);

  // Load the Crisp script once on mount
  useEffect(() => {
    if (!WEBSITE_ID || loaded.current) return;
    loaded.current = true;

    window.$crisp = [];
    window.CRISP_WEBSITE_ID = WEBSITE_ID;

    const script = document.createElement('script');
    script.src = 'https://client.crisp.chat/l.js';
    script.async = true;
    document.head.appendChild(script);
  }, []);

  // Identify / reset the user whenever auth state changes
  useEffect(() => {
    if (!WEBSITE_ID || !window.$crisp) return;

    if (user?.email) {
      window.$crisp.push(['set', 'user:email', [user.email]]);
    } else {
      // User signed out — reset the chat session so the next visitor is fresh
      window.$crisp.push(['do', 'session:reset']);
    }
  }, [user]);

  return null;
}
